import ListSalesCreditNotes from "../../../../components/@documents/sales_credit_notes/ListSalesCreditNotes";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesCreditNotesPage() {

    return (
        <ListSalesCreditNotes 
            routeType={routeTypes.admin}
        />
    )
}